import {Fragment, useContext} from 'react';

import {UserContext} from 'context';

import {AvatarSettings} from './AvatarSettings';
import {CreateSessionTokens} from './CreateSessionTokens';

export const ClientSettings: React.FC = () => {
    const {settings} = useContext(UserContext);

    return (
        <Fragment>
            <CreateSessionTokens />
            {settings.featuresAvailability.avatar && <AvatarSettings />}
        </Fragment>);
};